const jp = {
  common: {
    loading: "読み込み中...",
    please_wait: "少々お待ちください",
    kent_project: "KenT Projectの製品"
  },
  nav: {
    home: "ホーム",
    gallery: "ギャラリー",
    guide: "ガイド",
    create_frames: "フレームを作成",
    how_to_use: "使い方",
    about: "について",
    contact: "お問い合わせ"
  },
  home: {
    welcome_to: "ようこそ",
    subtitle: "2026年のトレンドフレームを数百種類そろえたオンライン撮影。アプリのダウンロード不要、透かしなし、プライバシーも安心。撮ったらすぐにシェアできます！",
    start_capture: "撮影開始",
    view_gallery: "ギャラリーを見る",
    follow_social: "FacebookとTikTokでKenT Photoboothをフォロー",
    social_popup_title: "フォローしてください！",
    social_popup_desc: "FacebookとTikTokでKenT Photoboothとつながり、最新のアップデートやフレームを受け取りましょう。",
    explore_now: "今すぐ探す",
    memory_corner: "思い出のコーナー",
    how_to_shoot: "フォトブースの写真の撮り方？",
    card1_title: "フレームを選ぶ",
    card1_desc: "フレームを選択し、「続ける」をクリックして撮影開始！",
    card2_title: "写真を撮る",
    card2_desc: "撮影後、「続ける」をクリックして次のページへ。1枚だけ撮り直したい場合は、その写真をクリックして「撮り直し」を押してください。",
    card3_title: "フレームを選んでダウンロード",
    card3_desc: "写真に合う色やフレームを選び、「ダウンロード」をクリックしてシェアしましょう。",
    feature_title: "自宅でプロ仕様のフォトブースを完全無料で",
    feature_sub1: "スムーズな体験",
    feature_sub2: "登録不要",
    feature_sub3: "広告なし",
    feature_sub4: "ウォーターマークなし",
    feature_layout_title: "多彩なレイアウトとフレーム",
    feature_layout_desc: "クラシックからモダンまで、豊富なレイアウトとフレームで創造性を発揮。あなたの写真をこれまで以上にユニークに。",
    feature_filter_title: "美しいフォトブースフィルター",
    feature_filter_desc: "フォトブーススタイルに特化したカラーフィルター。肌を明るく、色鮮やかに再現します。",
    feature_share_title: "ワンクリックでみんなにシェア",
    feature_share_desc: "簡単にダウンロード、またはQRコードで素早く共有。友人や家族と一瞬で喜びを分かち合えます。",
    shoot_now: "今すぐ撮影"
  },
  gallery: {
    title: "ギャラリー",
    heading: "あなたの瞬間 💙",
    photo_count: "枚の写真",
    secure: "100% 安全",
    free: "無料",
    send_photo: "写真を送ってください！",
    description: "ユーザーから送られた最もリアルな写真 — それぞれが忘れられない瞬間です。QRコード共有機能を除き、ウェブサイトはあなたの写真を保存しませんのでご安心ください！ダウンロード時または横のボタンから送ることができます！",
    loading_more: "さらに読み込み中...",
    no_photos: "まだ写真がありません"
  },
  guide_create: {
    title: "フレーム作成ガイド",
    subtitle: "Canvaを使ってフレームを作る方法",
    desc1: "基本的なフレームを用意しました。ぜひ創造性を発揮してください！ 🎨",
    desc2: "作成したフレームはカスタムフレーム機能で使用できます！",
    step1_title: "Canvaのフレームテンプレートを選ぶ",
    template4: "4枚テンプレート (1x4)",
    template4_desc: "縦並び4枚レイアウト用。",
    template6: "6枚テンプレート (2x3)",
    template6_desc: "6枚レイアウト用。",
    template2: "2枚テンプレート (2x2)",
    template2_desc: "2枚レイアウト用。",
    step2_note_title: "重要なメモ：",
    step2_note_desc: "中央の小さなフレーム内のカラーエリア（グレー、ブルー、または写真を入れる四角）を背景除去用の背景としてそのままにしてください。",
    step2_tip: "💡 背景のみのフレームを先にダウンロードし、背景を除去してからCanvaに戻してステッカーを追加することもできます（複雑なステッカーの除去をきれいに行うため）",
    step3_title: "画像をダウンロード",
    step3_desc: "デザインが完成したら、デバイスに新しいフレームをダウンロードして使用の準備をしましょう！",
    step4_title: "Photopeaで背景を除去",
    step4_desc: "🖼️ Photopeaでの背景除去ガイド",
    step4_li1: "Photopea.comにアクセス",
    step4_li2: "画像ファイルをドラッグするか「Ctrl + O」でCanvaからダウンロードした画像を開く。",
    step4_li3: "マジックワンドツールを選択。",
    step4_li4: "中央のカラーエリアをクリックして選択。",
    step4_li5: "キーボードのDeleteキーを押す。",
    step4_li6: "ファイル > 別名でエクスポート > PNG を選択。保存をクリック。",
    step5_title: "完成 & コミュニティ",
    step5_desc1: "✨ 透明なPNGファイルができました！ウェブサイトに戻り、フレーム選択ページの「カスタムフレームをアップロード」ボタンをクリックしてアップロードしてください。",
    step5_desc2: "🔒 ウェブサイトは画像を保存しませんので、安心してご利用いただけます！！！",
    step5_community: "一緒にコミュニティを作ろう",
    step5_community_desc1: "素晴らしいフレームを作成して、みんなに使ってもらいたい場合は、PNGファイルをInstagramで送ってください。",
    step5_community_desc2: "💜 あなたの貢献がフレームギャラリーを豊かにします。本当にありがとう！ ❤️"
  },
  guide_use: {
    title: "使い方",
    subtitle: "たった5つのステップで、友達とユニークなフォトブース写真を作って思い出に残せます！",
    step: "ステップ",
    step1_title: "旅を始める",
    step1_desc: "ホームページで「撮影開始」ボタンをクリック。カメラへのアクセスを許可することを忘れずに！（すべての画像はプライバシー保護のためデバイス上でローカル処理されます）。",
    step2_title: "レイアウトを選ぶ",
    step2_desc: "お気に入りの写真レイアウトを選択してください。かわいいレイアウトがたくさんあります。",
    step3_title: "ポーズ & 撮影",
    step3_desc: "お好みのカラーフィルターやエフェクトを選んでください。カメラアングルを調整し、ベストポーズで撮影しましょう！すべての写真を撮影したら「続ける」をクリック。",
    step4_title: "フレームを飾る",
    step4_desc: "スタイルに合った背景色を選んだり、ギャラリーから目を引くフレームを直接選んで写真を引き立てましょう。",
    step5_title: "保存 & シェア",
    step5_desc: "あなたの傑作が完成！高品質の画像をデバイスにダウンロードしたり、「Share QR」機能で友達にQRコードを送って共有できます。",
    ready: "準備はできていますか？",
    create_frame_btn: "独自のフレームを作成",
    start_btn: "今すぐ撮影開始",
    faq_title: "よくある質問",
    q1: "KenT Photoboothとは何ですか？",
    a1: "KenT Photoboothは、ソフトウェアをインストールすることなく、パソコンやスマートフォンのブラウザで直接フォトブーススタイルの写真を撮影できるウェブアプリケーションです。",
    q2: "ウェブサイトは私の写真を保存しますか？",
    a2: "いいえ、全く保存しません。すべての写真処理はブラウザ上（クライアントサイド）で直接行われます。写真は、スマートフォンに写真をダウンロードするために「QR共有」機能を明示的に選択した場合にのみ、サーバーに一時的に保存されます。",
    q3: "QR共有は安全ですか？",
    a3: "非常に安全です。共有リンクは自動的に期限切れになり、サーバー上のすべてのデータは1週間後に消去されます。特定のリンクやQRコードがない限り、誰もあなたの写真を見ることはできません。",
    q4: "自分でデザインしたフレームを使えますか？",
    a4: "はい！「フレーム作成」セクションでCanvaやPhotopeaを使った自作フレームの作り方を確認し、アップロードして個人的に使用することができます。",
    q5: "ウェブサイトは無料ですか？",
    a5: "ウェブサイトは100％無料です。「お問い合わせ」セクションから私をサポート（寄付）して、サーバーの維持にご協力いただけます！",
    steps_title: "実行手順",
    still_need_help: "まだ助けが必要ですか？",
    help_desc: "使用中に問題が発生した場合や、アイデアを提供したい場合は、お気軽にメッセージを送ってください！",
    contact_now: "今すぐ連絡する"
  },
  contact: {
    donate_title: "☕ コーヒーをごちそうして！",
    donate_desc: "サーバーの維持と新機能の開発のモチベーション維持のためにサポートをお願いします！ 💕",
    admin_badge: "管理者",
    contact_info: "連絡先情報",
    contact_desc: "このフォトブースウェブサイトは、かわいいmhoaへのプレゼントとして作りました 🥰💕",
    fb_page1: "Facebookページ",
    fb_page2: "Facebookページ"
  },
  about: {
    welcome: "KenT PhotoBoothへようこそ",
    title1: "瞬間を捉えよう",
    title2: "あなただけのやり方で",
    desc: "プロフェッショナルなフォトブース体験をブラウザにお届けします。高速、プライベート、完全無料。",
    team_title: "開発チーム",
    author_title: "作者：Que Minh Thanh (Dev 2k8)",
    author_desc: "KenT PhotoBoothシステムの基盤を築き、全体を構築した人物。技術と創造性への情熱を持つKenT Softwareが、誰でも使える便利なオンラインフォトブースのアイデアを実現しました。",
    designer_title: "フレームデザイナー：Que Minh Thanh、Que Mai Huong",
    designer_desc: "きらびやかで多様なフレームテンプレートを生み出したチーム。細部にこだわり、あなたの写真が特別で個性的なものになるよう尽力しています。",
    journey_title: "開発の歩み",
    m1_title: "プロジェクト開始",
    m1_desc: "デジタルフォトブースのアイデアの最初の一歩。すべてのフレームで喜びを届けたいという思いからプロジェクトがスタートしました。",
    m2_title: "最初の最終バージョン",
    m2_desc: "約2ヶ月の開発を経て、最初の完全版が正式にリリースされ、クリエイティブな旅の重要なマイルストーンとなりました。",
    m3_title: "オンライン公開",
    m3_desc: "プロジェクトを正式にオンラインへ。純粋なHTML、CSS、JSで構築され、最初の3週間で活発に運営されました。",
    m4_title: "再構築 & React",
    m4_desc: "全ソースコードをモダンなReactプラットフォームに移行した大きな転換点。同時にFacebook KenT Photoboothを開設してユーザーとの繋がりを構築。",
    m5_title: "正式再ローンチ",
    m5_desc: "新しいデザイン、優れたパフォーマンス、安定した動作で正式に帰ってきました。",
    features_title1: "最高レベルのセキュリティ",
    features_desc1: "あなたのデータは厳密に保護されており、自身のデバイス上で処理されます。写真はQR共有機能を使用した場合にのみサーバーに保存されます。",
    features_title2: "膨大なフレームライブラリ",
    features_desc2: "Y2K、エステティック、ビンテージなど、最新のトレンドを常に反映しています。",
    features_title3: "完全無料",
    features_desc3: "すべてのプレミアム機能を無料で体験できます。皆様の喜びが私たちの励みです。",
    features_title4: "即座に共有",
    features_desc4: "QRコードを作成して、数秒で友達と写真を共有できます。便利で超高速です。",
    features_title5: "シームレスな体験",
    features_desc5: "最適化されたインターフェース。モバイルからデスクトップまで、すべてのデバイスでスムーズに動作します。",
    features_title6: "鮮明な品質",
    features_desc6: "写真は高解像度でエクスポートされ、思い出のあらゆる細部が鮮やかでシャープなまま残ります。",
    cta_title: "美しい写真の準備はできましたか？",
    cta_desc: "KenT PhotoBoothユーザーコミュニティに参加して、今日から作り始めましょう。",
    cta_btn: "写真撮影を始める",
    users: "1000人以上のユーザー"
  },
  photo_layout: {
    title: "お気に入りのレイアウトを選んでください！",
    subtitle: "今後さらにフレームを追加予定です。 🌸",
    photos: "枚の写真",
    start_btn: "撮影開始",
    alert_select: "続ける前にレイアウトを選択してください。",
    layout_prefix: "レイアウト",
  },
  take_photo: {
    record_video_btn: "録画",
    settings_btn: "設定",
    layout_label: "レイアウト：",
    reselect_layout: "レイアウトを再選択",
    confirm_reselect: "レイアウトを再選択しますか？撮影済みの写真は失われます。",
    upload_photos: "写真をアップロード",
    camera: "カメラ",
    confirm_upload: "アップロードモードに切り替えますか？撮影済みの写真は失われます。",
    confirm_exit_video_mode: "撮影が完了する前にモードを切り替えますか？現在の写真は失われます。",
    flash_toggle: "フラッシュエフェクトの切り替え",
    flip_camera: "カメラを反転（ミラー）",
    alert_camera_off: "最初にカメラをオンにしてください！",
    confirm_retake: "写真 #を撮り直しますか",
    confirm_change: "この写真を変更しますか？",
    alert_need_photos: "続けるには{requiredPhotos}枚の写真が必要です！",
    filter_normal: "通常",
    filter_gray: "グレー",
    filter_sepia: "セピア",
    filter_bright: "明るい",
    filter_contrast: "シャープ",
    filter_blur: "ぼかし",
    slot: "スロット",
    support_off: "サポートオフ",
    support_on: "撮影サポート",
    capturing: "撮影中...",
    processing: "処理中...",
    processing_subtitle: "写真が処理されています...",
    manual_capture: "手動",
    retake_photo_btn: "写真 #を撮り直す",
    auto_capture: "自動",
    continue_btn: "続ける",
    confirm_retake_all: "すべて撮り直しますか？撮影済みの写真は失われます。",
    retake_all_btn: "すべて撮り直す",
    countdown_label: "⏱️ カウントダウン：",
    seconds: "秒",
    filter_title: "フィルター",
    effect_title: "エフェクト",
    effect_notice: "（撮影後に表示）",
    settings_title: "カメラ設定",
    select_camera: "カメラを選択：",
    camera_label: "カメラ",
    switch_camera_tip: "フロント/バックカメラを切り替え",
    mirror_label: "カメラをミラー",
    sound_label: "撮影音を有効にする",
    flash_screen_label: "フラッシュエフェクトを有効にする",
    live_gif_label: "写真と一緒にビデオを録画 (5秒)",
    close_btn: "閉じる",
    edit_title: "写真を編集",
    cancel_btn: "キャンセル",
    apply_btn: "適用",
    crop_tip: "丁寧にトリミングしてください！！！",
    support_modal_title: "サポートフレームを選択",
    support_modal_desc: "カメラ上の仮想フレームで位置合わせ用。実際のフレームは最後に選択します。",
    search_placeholder: "フレームを検索...",
    clear_support_btn: "現在のサポートフレームをオフにする"
  },
  result: {
    thanks: "ご利用ありがとうございます！",
    confirm_retake: "撮り直しますか？",
    upload_success: "写真をシェアしてくれてありがとう！",
    upload_error: "写真のアップロードエラー。",
    no_image_to_share: "シェアする画像が見つかりません。",
    error_load_frame: "カスタムフレームを読み込めません！",
    error_load_img: "フレームを読み込めません：",
    error_invalid_file: "無効なファイルです！PNG画像を選択してください。",
    cancel_btn: "キャンセル",
    photo_num: "写真",
    scroll_tip: "下にスクロールしてフォトフレームを飾りましょう",
    bg_color: "背景",
    photo_mode: "フォトモード",
    photo_frame: "フォトフレーム",
    use_custom_frame: "カスタムフレーム",
    search_frame_placeholder: "フレームを検索...",
    complete_btn: "完成",
    retake_btn: "撮り直す",
    contribute_title: "ライブラリへの貢献",
    contribute_question: "ギャラリーに写真をシェアしますか？",
    frame_upload_success: "カスタムフレームのアップロード成功！",
    qr_success: "QRコードが作成されました！",
    qr_error: "QRを作成できません。もう一度お試しください。",
    zoom_photo: "写真をズーム",
    share_qr_label: "QRをシェア",
    creating_qr: "作成中...",
    create_qr_btn: "QRを作成",
    share_your_photo: "写真をシェア",
    share_via_qr: "QRでシェア",
    generate_qr: "QRを生成",
    select_download_title: "ダウンロードする写真を選択",
    download_photo_title: "写真をダウンロード",
    save_all: "ストリップを保存",
    save_one: "1枚保存",
    download_btn: "ダウンロード",
    video_processing: "処理中...",
    download_video_btn: "ビデオをダウンロード",
    close_btn: "閉じる",
    your_photo_title: "あなたの写真",
    loading_photo: "写真を読み込み中...",
    one_photo: "1枚の写真",
    two_photos: "2枚の写真",
    custom_frame_title: "カスタムフレームをアップロード",
    frame_uploaded: "フレームがアップロードされました",
    drag_drop_tip: "ここに画像をドラッグ & ドロップ",
    or_click_tip: "またはクリックしてファイルを選択",
    yes_create_qr: "はい & QRを作成",
    no_continue_qr: "いいえ、QRのみ作成",
    generating_qr: "QRコードを生成中",
    generating_qr_desc: "写真をシェアするためのQRコードを生成しています。しばらくお待ちください！",
    your_qr_title: "あなたのQRコード",
    scan_qr_tip: "スマートフォンのカメラでQRコードをスキャンして写真をダウンロード！",
    or_copy_link: "またはリンクをコピー：",
    copied_link: "リンクをコピーしました！",
    storage_notice: "注意：この写真は1週間のみ有効です。その後、自動的に削除されます！",
    storage_note_title: "注意",
    storage_note_part1: "この写真は",
    storage_note_duration: "1週間",
    storage_note_part2: "のみ有効です。その後、自動的に削除されます！",
    thanks_title: "ありがとう！",
    share_invite: "みんなにシェアしてね！",
    frame_update_notice: "新しいフレームが常時追加されます ^^",
    contribute_question_alt: "この写真をパブリックコレクションに貢献しますか？",
    yes_contribute: "はい、貢献します",
    no_thanks: "いいえ、結構です",
    contribute_success: "貢献成功！",
  },
  share_view: {
    not_found: "写真が存在しないか、有効期限が切れています",
    load_error: "写真を読み込めません。もう一度お試しください。",
    loading_title: "写真を読み込み中...",
    loading_sub: "サーバーから写真を取得中",
    error_title: "写真が見つかりません",
    home_btn: "ホームに戻る",
    header_title: "写真をシェア",
    header_sub: "KenT Photoboothからシェアされました",
    one_photo: "1枚の写真",
    two_photos: "2枚の写真",
    tooltip_not_ready: "2枚バージョンの準備ができていません",
    tooltip_ready: "2枚表示",
    tag_layout: "レイアウト：",
    tag_frame: "フレームあり",
    tag_valid: "1週間有効",
    download_title: "ダウンロード",
    downloading: "ダウンロード中...",
    download_btn: "今すぐダウンロード",
    cta_text: "自分のフォトブースを作りたいですか？",
    cta_btn: "あなたのを作る",
    notice: "お知らせ：",
    notice_server: "この写真は1週間のみ有効で、自動的に削除されます。",
    notice_local: "このリンクはシェアした人がウェブサイト上にいる間のみ有効です。今すぐダウンロードしてください！",
    tip: "ヒント：写真を保存して美しい思い出を残しましょう！",
    created_by: "作成者",
    preparing: "写真を準備中...",
    preparing_sub: "PNG形式に最適化しています。",
    select_download_title: "ダウンロードする写真を選択",
    photo_num: "写真",
    cancel_btn: "キャンセル",
    download_btn: "ダウンロード",
    custom_frame_title: "カスタムフレームをアップロード",
    frame_uploaded: "フレームがアップロードされました",
    drag_drop_tip: "ここに画像をドラッグ & ドロップ",
    or_click_tip: "またはクリックしてファイルを選択",
    contribute_title: "ギャラリーへの貢献",
    contribute_question: "ギャラリーに写真をシェアしますか？",
    yes_create_qr: "はい & QRを作成",
    no_continue_qr: "いいえ、QRのみ作成",
    generating_qr: "QRコードを生成中",
    generating_qr_desc: "写真をシェアするためのQRコードを生成しています。しばらくお待ちください！",
    your_qr_title: "あなたのQRコード",
    scan_qr_tip: "スマートフォンのカメラでQRコードをスキャンして写真をダウンロード！",
    or_copy_link: "またはリンクをコピー：",
    copied_link: "リンクをコピーしました！",
    storage_notice: "注意：この写真は1週間のみ有効です。その後、自動的に削除されます！",
    close_btn: "閉じる",
    thanks_title: "ありがとう！",
    share_invite: "みんなにシェアしてね！",
    frame_update_notice: "新しいフレームが常時追加されます ^^",
    contribute_question_alt: "この写真をパブリックコレクションに貢献しますか？",
    yes_contribute: "はい、貢献します",
    no_thanks: "いいえ、結構です",
    contribute_success: "貢献成功！",
    your_photo_title: "あなたの写真",
    loading_photo: "写真を読み込み中...",
    one_photo: "1枚の写真",
    two_photos: "2枚の写真",
    download_photo_title: "写真をダウンロード",
    save_all: "ストリップを保存",
    save_one: "1枚保存",
    creating_qr: "作成中...",
    create_qr_btn: "QRを作成",
    share_your_photo: "写真をシェア",
    share_via_qr: "QRでシェア"
  },
  welcome_modal: {
    title: "ようこそ！",
    timer_title: "タイマーを選択",
    timer_body: "各ショットのカウントダウン時間を選択できます！",
    session_title: "連続撮影",
    session_body: "このセッションでは複数枚の写真を連続して撮影します。ベストポーズを決めてください！ 🌟",
    privacy_title: "プライバシーについて",
    privacy_body: "共有機能を使用しない限り、ウェブサイトは撮影した写真を保存しません。",
    start_btn: "スタート"
  },
  footer: {
    description: "フォトブースは高画質で友好的なインターフェースと、あらゆる年代向けのクリエイティブなエフェクトで思い出の瞬間を保存する場所です。",
    contact: "お問い合わせ",
    total_visits: "総訪問数："
  }
};


export default jp;
